<template>
  <button type="button"
          :class="[variant, {'submitted': submitted, 'error': error, 'loading': loading}]"
          @click="onClick">
    <transition @enter="enter"
                @leave="leave">
      <template v-if="loading">
        <slot name="loading">
          <font-awesome-icon key="foo"
                             icon="spinner"
                             spin></font-awesome-icon>
        </slot>
      </template>
      <template v-else>
        <template v-if="!submitted">
          <slot name="default">
          </slot>
        </template>
        <template v-else>
          <template v-if="error">
            <slot name="error">
              <font-awesome-icon key="error"
                                 class="icon"
                                 :icon="['fas', 'times']"></font-awesome-icon>
            </slot>
          </template>
          <template v-else>
            <slot name="success">
              <font-awesome-icon key="success"
                                 icon="check"></font-awesome-icon>
            </slot>
          </template>
        </template>
      </template>
    </transition>
  </button>
</template>

<script>
import { TweenMax } from "gsap";

export default {
  name: "ProcessingButton",
  props: {
    variant: {
      type: String,
      default: null,
    },
    action: {
      type: Function,
      default: null,
    },
    actionParams: {
      type: Array,
      default: () => [],
    },
    resultTime: {
      type: Number,
      default: 1750,
    },
  },
  data () {
    return {
      loading: false,
      submitted: false,
      error: false,
    };
  },
  methods: {
    onClick () {
      if ( this.action && typeof this.action === "function" ) {
        if ( !this.loading && !this.submitted ) {
          this.loading = true;
          this.submitted = false;
          this.error = false;
          this.action( ...this.actionParams )
            .then( () => {
            } )
            .catch( () => {
              this.error = true;
            } )
            .finally( () => {
              this.loading = false;
              this.submitted = true;
              window.setTimeout( () => {
                this.submitted = false;
                this.error = false;
              }, this.resultTime );
            } );
        }
      }
    },
    enter ( el, done ) {
      el.style.opacity = 0;
      el.style.position = "absolute";
      TweenMax.killTweensOf( el );

      TweenMax.to(
        el,
        0.25,
        {
          opacity: 1,
          onComplete: () => {
            el.style.position = "relative";
            done();
          },
        },
      );
    },
    leave ( el, done ) {
      TweenMax.killTweensOf( el );

      TweenMax.to(
        el,
        0.25,
        { opacity: 0, onComplete: done },
      );
    },
  },
};
</script>
